@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.bulkSelectSchoolsInputWrapper {
  margin-bottom: variables.$std-margin-lg;
}

.bulkConfigureLink {
  margin-left: variables.$std-margin-xs;
}
